// Modified Navigation.js
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import projectService from '../services/project/projectService';
import authService from '../services/auth/authService';
import '../styles/global.css';

const Navigation = ({ projectId }) => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [projectTitle, setProjectTitle] = useState(null);

  // Fetch project title
  useEffect(() => {
    const fetchProjectTitle = async () => {
      if (projectId) {
        try {
          const project = await projectService.getProjectById(projectId);
          if (project && project.title) {
            setProjectTitle(project.title);
          }
        } catch (error) {
          console.error("Error fetching project:", error);
        }
      }
    };

    fetchProjectTitle();
  }, [projectId]);

  const signOut = async () => {
    try {
      await authService.signOut();
      logout();
      navigate('/login');
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  // Don't show on login page
  if (location.pathname === "/login") {
    return null;
  }

  return (
    <div className="bg-white shadow-sm border-b border-gray-200">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            {/* Removed the "Face with Tongue" text that was here */}
            
            {projectTitle && (
              <div className="md:flex items-center">
                {/* Removed 'hidden' class to ensure visibility on mobile */}
                <span className="text-gray-600">{projectTitle}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation